var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapMarkerPosition',{ref:"googleMapsPopupRef",attrs:{"position":_vm.marker.position}})
}
var staticRenderFns = []

export { render, staticRenderFns }